// extracted by mini-css-extract-plugin
export default {"img":"SampleDashboardImage_img__EKkQv","container":"SampleDashboardImage_container__r12+4"};